import React from "react";
import { Redirect, Switch } from "react-router";
import AuthenticatedRoute from "../components/AuthenticatedRoute";
import UnauthorizedRoute from "../components/UnauthorizedRoute";
import roles from "../utils/roles";
import { LayoutContainer as Layout } from "../layouts/Layout";
import Login from "./pages/Authorization";
import Main from "./pages/Main";

export default React.memo(() => {
    return (
      <Layout>
        <Switch>
          <UnauthorizedRoute path={"/login"}
                             component={Login} />
          <AuthenticatedRoute path={"/booking"}
                              requiredRole={roles.authorized}
                              component={Main} />
          <Redirect to={"/booking"} />
        </Switch>
      </Layout>
    );
  },
);
